import React , {Component} from 'react';

class Loading extends Component{
    render(){
        const { show } = this.props;
        return(
            <div id="request-loading" className={show === true ? 'd-flex' : 'd-none'}>
                <i className="fas fa-circle-notch icon"></i>
            </div>
        )
    }
}


export default Loading;